/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import axios from "axios";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import config from "../../../../../../config.json";
import videImg from "../../../../../assets/images/vide-item.png";
import "../../../../../i18n";
import { useTranslation } from "react-i18next";
import { mediaFileUrl } from "../../../Cms/MenuTree/menuTreeUtils";

const Items = ({ item, fetchItems }) => {
  const { t } = useTranslation();
  const { _id, photo, itemDetails = [], isArchived } = item;
  // CDN does not serve /uploads/items/ (404); item files are under /product/.
  const photoSrc = mediaFileUrl("product", photo) || videImg;

  const hideItem = async () => {
    try {
      await axios.put(`${config.dev}/v2/items/hide/${_id}`).then(() => {
        swal("SUCCESS", "Item is in hide mode", "success");
      });
      fetchItems();
    } catch (error) {
      swal("ERROR", "" + error, "error");
    }
  };

  if (isArchived) return null;

  return (
    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-4">
      <div className="card kitchen-card">
        <div className="card-body">
          <div className="new-arrival-product">
            <div className="kitchen-card__top">
              <div className="basic-dropdown kitchen-card__menu">
                <Dropdown>
                  <Dropdown.Toggle
                    variant="outline-secondary"
                    className="btn-sm"
                    id="item-actions"
                  >
                    <i className="fas fa-ellipsis-v" />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item
                      as={Link}
                      to={`/item-details/${_id}`}
                      className="kitchen-action-view"
                    >
                      <i className="fas fa-eye me-2" />
                      {t("details")}
                    </Dropdown.Item>
                    <Dropdown.Item
                      as={Link}
                      to={`/edit-item/${_id}`}
                      className="text-warning"
                    >
                      <i className="fas fa-pen me-2 text-warning" />
                      {t("edit")}
                    </Dropdown.Item>
                    <Dropdown.Item onClick={hideItem} className="text-danger-dark">
                      <i className="fas fa-archive me-2 text-danger-dark" />
                      {t("archive")}
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>

            <div className="new-arrivals-img-contnent kitchen-card__media">
              <img
                className="img-fluid kitchen-card__photo"
                src={photoSrc}
                alt={
                  itemDetails.find((detail) => detail.language === "en")
                    ?.itemTitle ||
                  itemDetails[0]?.itemTitle ||
                  ""
                }
                onError={(e) => {
                  e.currentTarget.onerror = null;
                  e.currentTarget.src = videImg;
                }}
              />
            </div>

            <div className="new-arrival-content kitchen-card__title">
              <h4>
                <Link to="#">
                  {itemDetails.map((detail) =>
                    detail.language === "en" ? detail.itemTitle : null
                  )}
                </Link>
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Items;
